// File: src/services/apiService.js

import { API_CONFIG } from '../config/api';

const FRONTEND_ACTIONS_ENDPOINT = '/frontend-actions';

class ApiService {
  constructor() {
    this.baseUrl = API_CONFIG.baseUrl;
    this.enterpriseId = API_CONFIG.enterpriseId;
  }

  async executeCommand(command, data = {}) {
    const requestBody = {
      command,
      data: {
        ...data,
        enterprise_id: this.enterpriseId
      }
    };

    try {
      const response = await fetch(`${this.baseUrl}${FRONTEND_ACTIONS_ENDPOINT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      const result = await response.json();

      if (!response.ok) {
        const error = new Error(result.error || result.message || `HTTP ${response.status}`);
        error.code = result.code;
        error.details = result.details;
        error.status = response.status;
        throw error;
      }

      return result;

    } catch (error) {
      console.error('[ApiService] Error:', {
        command,
        message: error.message,
        code: error.code,
        status: error.status
      });
      throw error;
    }
  }

  async submitContactForm(data) {
    return this.executeCommand('submitContactForm', data);
  }
}

const apiService = new ApiService();
export default apiService;